// extracted by mini-css-extract-plugin
export default {"appointment":"appointment-733d","items-container":"items-container-9369","item":"item-a3eb","icon":"icon-8453","image-container":"image-container-14d8"};